























import SidebarDonate from '@/components/SidebarDonate.vue'

export default {
  name : 'Pledges',
  components: {
	  SidebarDonate
  }
}
